import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Tooltip, WixIcons } from '..';
import styles from './TranscodingOverlays.scss';

export const ErrorOverlay: React.FC = () => (
  <div className={styles.loader}>
    <Tooltip content={<FormattedMessage id="files-manager.tooltips.transcoding-error" />} maxWidth={210}>
      <div className={styles.error} data-hook="transcoding-error-label">
        <WixIcons.StatusAlertFilled className={styles.errorIcon} />
      </div>
    </Tooltip>
  </div>
);
